import React from 'react';

import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import { PublicJobSummary } from 'networking/public/jobs/public-jobs-client';

import {
  JobRowArrow,
  JobRowComp,
  JobRowLink,
  JobRowMain,
  JobRowMeta,
  JobRowMetaSeparator,
  JobRowTitle,
} from './styled-components';

interface JobsListRowProps {
  job: PublicJobSummary;
}

export const JobsListRow: React.FC<JobsListRowProps> = ({ job }) => {
  const metaSegments: { key: string; node: React.ReactNode }[] = [
    { key: 'location', node: <span>{job.location}</span> },
    { key: 'type', node: <span>{job.employmentType}</span> },
  ];

  if (job.compensationSummary) {
    metaSegments.push({
      key: 'comp',
      node: <JobRowComp>{job.compensationSummary}</JobRowComp>,
    });
  }

  return (
    <JobRowLink to={`/jobs/${job.publicSlug}`}>
      <JobRowMain>
        <JobRowTitle>{job.publicTitle}</JobRowTitle>

        <JobRowMeta>
          {metaSegments.map((segment, index) => (
            <React.Fragment key={segment.key}>
              {index > 0 ? <JobRowMetaSeparator aria-hidden /> : null}

              {segment.node}
            </React.Fragment>
          ))}
        </JobRowMeta>
      </JobRowMain>

      <JobRowArrow>
        <ArrowForwardRoundedIcon aria-hidden />
      </JobRowArrow>
    </JobRowLink>
  );
};
